import {
  apiPost,
  getApiUrl,
  type PostStoriesUploadImageFetchResponse,
  type PostStoriesUploadVideoFetchResponse,
  postStoriesUploadImagePath,
  postStoriesUploadVideoPath,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

export type StoryMediaKind = "image" | "video";

type Parameters = {
  kind: StoryMediaKind;
  file: File;
};

const UPLOAD_PATHS: Record<StoryMediaKind, () => string> = {
  image: postStoriesUploadImagePath,
  video: postStoriesUploadVideoPath,
};

// The generated postStoriesUpload* clients can't be used directly: rest2ts emits multipart
// endpoints without the IFormFile parameter, so the FormData is built here — but the request
// still goes through `apiPost`, so the response middlewares (the global 401 logout among them)
// see it like every other authenticated call. The response cast is the one the generated
// clients themselves make onto their FetchResponse union.
const upload = processResponseWithApiProblemDetails(
  ({ kind, file }: Parameters) => {
    const form = new FormData();
    form.append("file", file);

    return apiPost(
      `${getApiUrl()}${UPLOAD_PATHS[kind]()}`,
      form,
      {},
    ) as Promise<
      PostStoriesUploadImageFetchResponse | PostStoriesUploadVideoFetchResponse
    >;
  },
);

/** Shared story media upload; resolves to the public URL of the stored file. */
export const uploadStoryFile = async (
  kind: StoryMediaKind,
  file: File,
): Promise<string> => (await upload({ kind, file })).url;
